import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { getDateWithoutTime } from '@/shared/utils'
import type { VisitorType } from '@/shared/types/store.types'
import { formatHolderFullName } from '../QuoteWidget.helpers'

export const usePassportExpiryGuard = () => {
  const { t } = useI18n()

  const showAlert = ref(false)
  const alertText = ref('')

  const isBlocked = computed(() => alertText.value.length > 0 && showAlert.value)

  const check = (matchingList: VisitorType[]): boolean => {
    const currentDate = getDateWithoutTime(new Date()).getTime()
    const expired: string[] = []

    matchingList.forEach((visitor) => {
      if (visitor.passportExpiryDate) {
        const expiryDate = getDateWithoutTime(new Date(visitor.passportExpiryDate)).getTime()
        if (expiryDate < currentDate) {
          expired.push(formatHolderFullName(visitor).trim())
        }
      }
    })

    if (expired.length > 0) {
      showAlert.value = true
      alertText.value = `${t('visitors.quote.passport_expired.alert')}${expired.join(', ')}`
      return false
    }

    showAlert.value = false
    alertText.value = ''
    return true
  }

  const clear = () => {
    showAlert.value = false
    alertText.value = ''
  }

  return { showAlert, alertText, isBlocked, check, clear }
}
